var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59998 16.6679H1.19301V5.6585H4.59998V16.6679ZM2.89467 4.15672C1.80546 4.15672 0.921631 3.25123 0.921631 2.15803C0.921631 1.06482 1.80546 0.177734 2.89467 0.177734C3.98387 0.177734 4.8677 1.06482 4.8677 2.15803C4.8677 3.25123 3.98387 4.15672 2.89467 4.15672ZM17.3514 16.6679H13.9517V11.3086C13.9517 10.0313 13.9261 8.39336 12.1804 8.39336C10.4091 8.39336 10.1377 9.78104 10.1377 11.2166V16.6679H6.73438V5.6585H10.002V7.16028H10.0497C10.5044 6.29529 11.6156 5.38244 13.2733 5.38244C16.7206 5.38244 17.355 7.66088 17.355 10.6203V16.6679H17.3514Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.62a65497.svg";
export { ForwardRef as ReactComponent };